import React from 'react'
import * as S from './styled'
const Dane = ({ description, links, slug }) => {
  return (
    <>
      <S.P>{description}</S.P>
      <S.Link href={slug} btn>
        Více
      </S.Link>
      <S.UnderlineYellow />
      {links &&
        links.map(link => (
          <S.Link key={link.slug} href={slug + link.slug}>
            {link.name}
          </S.Link>
        ))}
    </>
  )
}

export default Dane
